<template>
  <div :style="wrapperStyle">
    <template v-if="mode === 'prev' || mode === 'next'">
      <PaginationButton
        :direction="mode"
        :disabled="mode === 'prev' ? !canPrev : !canNext"
        :size="size"
        @click="handleClick(mode === 'prev' ? 'prev' : 'next')"
      />
    </template>
    <template v-else>
      <PaginationButton direction="prev" :disabled="!canPrev" :size="size" @click="handleClick('prev')" />
      <PaginationButton direction="next" :disabled="!canNext" :size="size" @click="handleClick('next')" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, type CSSProperties } from 'vue'
import PaginationButton from './pagination-button.vue'


const props = withDefaults(defineProps<{
  canPrev: boolean
  canNext: boolean
  mode?: 'prev' | 'next' | 'stacked' | 'inline'
  placement?: 'both' | 'single'
  size?: 'large' | 'small'
}>(), {
  mode: 'inline',
  size: 'large',
})

const emit = defineEmits<{
  (e: 'prev'): void
  (e: 'next'): void
}>()

function handleClick(direction: 'prev' | 'next') {
  if (direction === 'prev') emit('prev')
  else emit('next')
}

const wrapperStyle = computed<CSSProperties>(() => {
  const base: CSSProperties = {
    display: 'flex',
    alignSelf: 'stretch',
    justifyContent: 'center',
    minWidth: '20px',
  }
  if (props.mode === 'prev' || props.mode === 'next') {
    return { ...base, alignItems: 'center' }
  }
  if (props.mode === 'stacked') {
    return { ...base, flexDirection: 'column', gap: '8px', alignItems: 'center' }
  }
  return { ...base, alignItems: 'center', gap: '8px' }
})
</script>
